import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { SearchField, SearchFieldProps } from '../../SearchField/SearchField';

export const Root = styled.div`
  width: 100%;
  padding: ${globalTheme.spacing.sm} ${globalTheme.spacing.lg};
  flex: 1;
`;

export const Search: React.FC<React.PropsWithChildren<SearchFieldProps>> = ({ className, ...searchFieldProps }) => (
  <Root data-test="search-wrapper" className={className}>
    <SearchField {...searchFieldProps} />
  </Root>
);
